import { useTranslation } from 'react-i18next'
import { Alert, AlertProps, AlertTitle, Button, Stack } from '@mui/material'
import { Valve } from '../types'
import ValveDetachInRuuviTagButton from './ValveDetachInRuuviTagButton'

export interface ValveDetachInRuuviTagAlertProps extends Omit<AlertProps, 'children' | 'onChange'> {
  valve: Valve
  title?: string
  onValveChange?: (valve: Valve) => void
  onCancel?: () => void
}

export default function ValveDetachInRuuviTagAlert({
  valve,
  title,
  onValveChange,
  onCancel,
  sx,
  ...props
}: ValveDetachInRuuviTagAlertProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('valve')

  /**
   * Handle the "after submit" event.
   */
  function handleAfterSubmit(valve: Valve) {
    onValveChange?.(valve)
  }

  return (
    <>
      {valve?.inRuuviTag && (
        <Alert
          severity="warning"
          sx={{
            '& .MuiAlert-message': {
              width: '100%'
            },
            ...sx
          }}
          {...props}
        >
          <AlertTitle sx={{ m: 0 }}>{title ?? t('ValveDetachInRuuviTagAlert.title')}</AlertTitle>

          <Stack direction="row" alignItems="center" gap={2} sx={{ mt: 2 }}>
            <ValveDetachInRuuviTagButton
              valve={valve}
              variant="outlined"
              color="inherit"
              size="small"
              buttonText={t('ValveDetachInRuuviTagAlert.yes')}
              afterSubmit={handleAfterSubmit}
            />

            <Button variant="outlined" color="inherit" size="small" onClick={onCancel}>
              {t('ValveDetachInRuuviTagAlert.no')}
            </Button>
          </Stack>
        </Alert>
      )}
    </>
  )
}
